<div class="flex flex-col h-full bg-gray-100 w-full max-w-[950px] mx-auto px-6 py-4">

    <!-- Navigation haut -->
    <div class="flex justify-start items-center mb-6">
        <button (click)="goBack()"
            class="w-12 h-12 bg-blue-700 hover:bg-blue-800 text-white rounded-sm flex items-center justify-center shadow">
            <i class="fas fa-chevron-left text-lg"></i>
        </button>
    </div>

    <h2 class="text-2xl font-semibold text-gray-800 mb-6">{{ 'vues.ipad.generate.title' | translate }}</h2>

    <!-- Recherche employé -->
    <div class="flex items-center gap-3 mb-4">
        <div class="flex-1">
            <app-multi-select
                [options]="employees()"
                [isMultiselect]="false"
                [minChars]="3"
                [skin]="Skin"
                [placeholder]="'vues.ipad.generate.search-placeholder' | translate"
                [maxItems]="1"
                [selectedKeys]="selectedKeys()"
                (selectedKeysChange)="onEmployeeSelectChange($event)">
            </app-multi-select>
        </div>
        @if (selectedKeys().length > 0) {
        <i class="fas fa-check text-green-500 text-2xl"></i>
        }
    </div>
    <p class="text-sm text-gray-500 mb-6">{{ 'vues.ipad.generate.search-hint' | translate }}</p>

    <!-- Boutons -->
    <div class="flex gap-3 mb-8">
        <button (click)="cancel()"
            class="px-6 py-3 bg-red-500 hover:bg-red-600 text-white rounded-sm shadow font-semibold">
            {{ 'vues.ipad.generate.cancel' | translate }}
        </button>
        <button (click)="generate()" [disabled]="selectedKeys().length === 0"
            class="px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-sm shadow font-semibold disabled:opacity-50 disabled:cursor-not-allowed">
            {{ 'vues.ipad.generate.button' | translate }}
        </button>
    </div>

    <!-- QR généré -->
    @if (generatedQrCode()) {
    <div class="flex flex-col items-center gap-3 bg-white rounded-md shadow p-6 w-fit mx-auto">
        <p class="text-lg font-semibold text-gray-800">{{ generatedEmployeeName() }}</p>
        <div #qrCodeContainer class="qr-preview"></div>
    </div>
    }

    <!-- Footer -->
    <div class="mt-auto flex justify-start pt-8">
        <button (click)="goHome()" class="flex items-center gap-2 text-gray-700">
            <i class="fas fa-home text-2xl"></i>
            <span>{{ 'vues.ipad.back.home' | translate }}</span>
        </button>
    </div>

</div>
